import * as React from "react";
import { formatMoney } from "../../../shared/api/formatutil";
import { CartItem } from "../../interfaces/cart";

interface CartDisplayItemGenericProps {
    cartitem: CartItem;
}

// Generic items
const CartDisplayItemGeneric = ({ cartitem }: CartDisplayItemGenericProps) => {
    let description: React.JSX.Element | null = null;
    if (cartitem.description) {
        description = (
            <div className="item-description">{cartitem.description}</div>
        );
    }

    return (
        <>
            <div className="item-caption">
                <div className="item-name">{cartitem.name}</div>
                {description}
            </div>
            <div className="item-price">{formatMoney(cartitem.price)}</div>
        </>
    );
};

export default CartDisplayItemGeneric;
